@if (theme) {
  <div class="font-body bg-cover multi-column {{ theme?.root }} {{topLevelClasses}}" [style]="theme?.bgImage">
    <div class="{{containerLevelClasses}} container {{ theme?.container }}"
      [ngClass]="{'!max-w-[720px]': data.columnList.length === 1}" (click)="modalWrapperClickHandler($event)">
      @if (data.componentTitle !== null && data.componentTitle?.length !== 0) {
        <div
          class="py-v-spacing sm:px-v-spacing max-w-container mx-auto wysiwyg multi-column__title"
          [innerHTML]="data.componentTitle"
        ></div>
      }
      <div class="flex flex-col lg:flex-row justify-center"
        [class.lg:divide-x]="data.addVerticalSeparators"
        [class.divide-[#D3DDDF]]="data.addVerticalSeparators">
        @for (column of data.columnList; track column; let index = $index) {
          <div
            class="multi-column__column py-v-spacing w-full {{ theme?.columnWidths[index] }}"
        [ngClass]="{
          'sm:px-v-spacing max-w-container mx-auto': data.columnList.length === 1,
          'sm:px-v-spacing': data.columnList.length > 1,
        }"
            >
            <div class="wysiwyg" [innerHTML]="column.columnContent" shortcodeRenderer [hasVerticalSeparators]="data.addVerticalSeparators"></div>
            <!--Optional dropdown-->
            @if (column.dropdownTitle && column.dropdown.length > 0) {
              <div class="py-v-spacing sm:px-v-spacing">
                <vision-dropdown [dropdownData]="setDropdownData(column.dropdown, column.dropdownTitle, column.dropdownAlignment)"></vision-dropdown>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
